module.exports = __webpack_public_path__ + "static/img/son6_active.c7cd8b76.png";